export default __webpack_public_path__ + "static/media/full-icon.b1177673.svg";